module.exports = __webpack_public_path__ + "img/76182.470b5136.svg";